import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class ThemeService extends Service {
  @tracked isDark = false;

  constructor(properties?: object) {
    super(properties);

    // Sync with current state from DOM
    if (typeof document !== 'undefined') {
      this.isDark = document.documentElement.classList.contains('dark');
    }
  }

  @action
  toggleTheme() {
    this.isDark = !this.isDark;
    this.applyTheme();

    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('theme', this.isDark ? 'dark' : 'light');
    }
  }

  applyTheme() {
    if (typeof document !== 'undefined') {
      if (this.isDark) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    }
  }

  get currentTheme(): string {
    return this.isDark ? 'dark' : 'light';
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    theme: ThemeService;
  }
}

